import sha1 from 'js-sha1';

import type { Message } from '../redux/messages/types';
import { getPlainMessage } from './get_plain_message';

export function getMessageHash(message: Message) {
  return `${message.variant}:${sha1(getPlainMessage(message.text))}`;
}
